import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
/**
 * Catches render errors anywhere in the tree and shows a recoverable
 * fallback instead of a blank white screen.
 */
export class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        console.error('[ErrorBoundary]', error, info.componentStack);
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gray-50 p-4", children: _jsxs("div", { className: "max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center", role: "alert", children: [_jsx("h1", { className: "text-xl font-bold text-gray-900 mb-2", children: "Something went wrong" }), _jsx("p", { className: "text-sm text-gray-600 mb-6", children: "An unexpected error occurred. Please try reloading the page \u2014 if the problem persists, contact support." }), _jsx("button", { onClick: () => window.location.reload(), className: "w-full bg-gray-900 text-white font-semibold py-2.5 rounded-xl hover:bg-gray-700 transition-colors", children: "Reload page" })] }) }));
        }
        return this.props.children;
    }
}
